import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from, switchMap, tap } from 'rxjs';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';

/**
 * Interceptor adds the user's auth token to any HTTP request
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Default constructor for the interceptor 
     * @param _userService
     */
    constructor(
        private _userService: UserService,
    ) {}

    /**
     * Intercept any HTTP request 
     * @param req
     * @param next 
     * @returns HTTP Response
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this._userService.token$).pipe(
            switchMap((token: string): Observable<HttpEvent<any>> => {
                if (token == undefined || token === "") return new Observable<HttpEvent<any>>();

                // Clone the request with the added token
                const req1 = req.clone({
                    headers: req.headers.set('Authorization', `${token}`),
                });

                // Let the http handler handle the updated request
                return next.handle(req1);
            })
        );
    }
}